<style lang="less" scoped>
.title-div {
  font-weight: 600;
  margin: 20px 0 10px;
  font-size: 26px;
  // flex-grow: 1;
  color: #000;
}

.history {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #4182eb;
  line-height: 20px;
  height: 25px;
  margin-top: 35px;
  margin-left: 15px;
}

.custInfo_container {
  width: 100%;
  margin: 20px 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  display: flex;

  .cust-item {
    width: 25%;
  }
}

.el-col {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin: 10px 0;

  >div:first-of-type {
    // width: 120px;
    text-align: left;
    font-size: 14px;
    font-weight: 400;
  }

  >div:last-of-type {
    font-size: 14px;
    min-width: 160px;
    text-align: right;
  }
}

// .cust-detail-item {
//   // t-w
// }
.page-action-btns {
  margin-bottom: 10px;
}

.cust-mes {
  margin: 0px 0px 14px 18px;
}

.top-title-div {
  font-size: 15px;
  margin-left: 10px;
}

.red-tip {
  color: #f56c6c;
  font-size: 12px;
  margin-left: 100px;
}

.detail-btn {
  height: 32px;
  margin-left: 45px;
  margin-top: 10px;
}

.account_item {
  width: 237px;
  height: 101px;
  background: #4182eb;
  border-radius: 22px;
  color: #fff;
  display: flex;
  align-items: center;
  padding: 10px 20px;
  margin-right: 50px;

  .img_con {
    width: 61px;
    height: 61px;
    background: #ffffff;
    border-radius: 50%;
    line-height: 75px;
    text-align: center;
  }

  .amount_con {
    flex-grow: 1;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    text-align: right;
  }

  .amount_con :last-child {
    font-size: 26px;
    font-weight: 500;
  }
}
</style>

<template>
  <div class="detail-content-div">
    <div class="title-div">积分信息</div>
    <div class="flex">
      <div class="account_item">
        <div class="img_con">
          <img src="../../assets/detail/integral.png" alt="" />
        </div>
        <div class="amount_con">
          <p>账户积分</p>
          <p>{{ detailForm.totalIntegral }}</p>
        </div>
      </div>
      <div class="account_item">
        <div class="img_con">
          <img src="../../assets/detail/gain.png" alt="" />
        </div>
        <div class="amount_con">
          <p>累计收获</p>
          <p>{{ integralCount }}</p>
        </div>
      </div>
      <div class="account_item">
        <div class="img_con">
          <img src="../../assets/detail/spend.png" alt="" />
        </div>
        <div class="amount_con">
          <p>累计消耗</p>
          <p>{{ integralConsume }}</p>
        </div>
      </div>
      <div class="account_item">
        <div class="img_con">
          <img src="../../assets/detail/spend.png" alt="" />
        </div>
        <div class="amount_con">
          <p>已失效</p>
          <p>{{ expirationIntegral }}</p>
        </div>
      </div>
    </div>
    <div class="flex">
      <div class="title-div">积分流水信息</div>
    </div>
    <div class="flex" style="justify-content:space-between;align-items:center;">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="全部流水" name="first"></el-tab-pane>
        <el-tab-pane label="获取" name="hq"></el-tab-pane>
        <el-tab-pane label="消耗" name="xh"></el-tab-pane>
        <el-tab-pane label="失效积分" name="sx"></el-tab-pane>
      </el-tabs>

      <div class="query-flex-btns-div margin-bottom-16">
        <el-input style="width: 300px;" size="small" v-model="queryInfo.integralId" placeholder=" 请输入积分流水号"></el-input>
        <button class="common-bg-button" @click="getData(pagination, true)">
          搜 索
        </button>
        <button class="common-bg-button" @click="resetQuery()">重 置</button>
      </div>
    </div>
    <el-table class="el-table" :data="activeName == 'first'
        ? tableData
        : activeName == 'hq'
          ? hqList
          : activeName == 'xh'
            ? xhList
            : activeName == 'sx'
              ? sxList
              : []
      " border max-height="500px" style="width: 100%;margin:20px auto" :cell-style="{ 'text-align': 'center' }"
      :header-cell-style="{
        background: '#FAFAFA',
        color: '#8F9BB3',
        fontSize: '14px',
        textAlign: 'center',
        border: '1px solid #F0F0F0',
      }">
      <!-- <el-table-column prop="userPhone" width="120" label="用户手机号">
      </el-table-column> -->


      <el-table-column prop="integralId" width="220" label="积分流水号">
      </el-table-column>
      <el-table-column v-if="activeName == 'xh'" prop="couponExchangeNo" width="120" label="优惠券兑换流水号">
      </el-table-column>
      <el-table-column v-if="activeName == 'xh'" prop="couponNo" width="120" label="优惠券编号">
      </el-table-column>

      <el-table-column prop="sourceName" width="200" label="渠道">
      </el-table-column>
      <el-table-column v-if="activeName == 'hq'" prop="integralStatus" width="200" label="积分状态">
      </el-table-column>
      <el-table-column v-if="activeName == 'hq'" prop="integralProcessName" width="200" label="获取方式">
      </el-table-column>
      <el-table-column v-if="activeName != 'xh'" prop="integralType" label="类型">
        <template slot-scope="scope">
          <span v-if="scope.row.integralType == '01'">获取</span>
          <span v-if="scope.row.integralType == '02'">消耗</span>
          <span v-if="scope.row.integralType == '03'">失效</span>
        </template>
      </el-table-column>
      <el-table-column v-if="activeName == 'xh'" prop="exchangeStatusName" label="发放状态">
        <!-- <template slot-scope="scope">
          <span v-if="scope.row.exchangeStatusName == '01'">成功</span>
          <span v-if="scope.row.exchangeStatusName == '02'">失败</span>
        </template> -->
      </el-table-column>
      <el-table-column prop="integralCount" label="积分数"> </el-table-column>
      <el-table-column v-if="activeName == 'xh'" prop="couponName" label="兑换内容"> </el-table-column>
      <el-table-column v-if="activeName != 'xh'" prop="beforeChangeCount" label="变动前">
      </el-table-column>
      <el-table-column v-if="activeName != 'xh'" prop="afterChangeCount" label="变动后">
      </el-table-column>
      <el-table-column prop="integralTime" width="200" label="变动时间">
      </el-table-column>


    </el-table>
    <!-- 分页 -->
    <div class="list-pagination">
      <ZD-pagination :pagination="pagination" v-on:pageUpdate="getData"></ZD-pagination>
    </div>
    <div class="flex-r-end">
      <button class="common-empty-button" @click="back()">返 回</button>
    </div>
  </div>
</template>

<script>
import pageConfig from '../operationConfiguration/couponManagement/couponAllocation/page-config'
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      activeName: "first",
      pagination: pageConfig.pagination,
      editFlag: false,
      integralCount: "0",
      integralConsume: "0",
      expirationIntegral: "0",
      pageTitle: "客户详情",
      // 默认值设置
      custInfo: {},
      detailForm: {},
      custDto: {}, //未使用
      queryInfo: {}, // 默认内容
      dialogForm: {
        //度电设置弹窗内容
        remark: "",
        chargeValue: "",
      },
      hqList: [],
      xhList: [],
      sxList: [],
    };
  },
  methods: {
    handleClick(val) {
      console.log(val);
      this.activeName = val.name;
      if (val.name == "hq") {
        this.hqList = [];

        this.queryInfo.integralType = '01'
        this.getData(this.pagination, true)
      }
      if (val.name == "xh") {
        this.xhList = [];
        this.queryInfo.integralType = '02'
        this.getData(this.pagination, true)
      }
      if (val.name == "sx") {
        this.sxList = [];
        this.queryInfo.integralType = '03'
        this.getData(this.pagination, true)
      }
    },

    init() {
      if (this.$store.state.custObj) {
        this.custInfo = this.$store.state.custObj;
        this.queryInfo.userPhone = this.custInfo.mobile;
        this.detailForm.totalIntegral =
          this.$store.state.custObj.totalIntegral || "0";
        this.getData(this.pagination, true)
        this.getSumIntegralCount();
      }
    },
    // 获取表格数据
    getData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        _.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      _.$U.showLoading(_);
      _.$H.post(_, _.$A.cust.getIntegralPage, _.queryInfo).then((res) => {
        if (this.queryInfo.integralType == '01') {
          this.hqList = res.data.data.content || [];
        }
        if (this.queryInfo.integralType == '02') {
          this.xhList = res.data.data.content || [];
        }
        if (this.queryInfo.integralType == '03') {
          this.sxList = res.data.data.content || [];
        }
        if (this.activeName == 'first') {
          _.tableData = res.data.data.content || [];
        }

        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      });
    },
    // 车辆信息 - 表格数据
    getSumIntegralCount() {
      let _ = this;
      _.$U.showLoading(_);
      _.$H.post(_, _.$A.cust.getSumIntegralCount, _.queryInfo).then((res) => {
        _.integralCount = res.data.data.integralCount
          ? res.data.data.integralCount
          : "0";
        _.integralConsume = res.data.data.integralConsume
          ? res.data.data.integralConsume
          : "0";
        _.expirationIntegral = res.data.data.expirationIntegral
          ? res.data.data.expirationIntegral
          : "0";
        _.$U.hideLoading(_);
        // console.log(_.detailForm);
      });
    },
    resetQuery() {
      this.queryInfo = {
        searchKey: undefined,
      };
      this.getListData(this.pagination, true);
    },
    back() {
      this.$router.push({
        name: "custList",
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
